import { memo } from 'react';

import ForbiddenIcon from '@/assets/forbidden-icon.svg?react';
import { FormatterValidatorLogo, VariantLogoProps } from '@/components/logos';

export type NonEmptyLogoProps = VariantLogoProps;

const INonEmptyLogo = ({ ...rest }: NonEmptyLogoProps) => {
  return <FormatterValidatorLogo Icon={ForbiddenIcon} iconColoringType="stroke" {...rest} />;
};

export const NonEmptyLogo = memo(INonEmptyLogo) as typeof INonEmptyLogo;
